import React from "react";


function FormError(props) {
    return  (
        <>
            {(props.error && (typeof props.error === "string")) &&
                <div className="form-error form-field-error">{props.error}</div>
            }
        </>
    );
}

export { FormError };